<template>
  <form
    class="login__form"
    :class="{
      login__mobileshown: isAuthMobileForm,
    }"
    @submit.prevent="onSubmit"
    ref="form"
  >
    <p class="form__title">Вход</p>
    <div class="form__input-wrapper">
      <BaseInput
        v-model="auth.username"
        name="username"
        type="text"
        :hasError="$v.auth.username.$error"
        label="Логин"
        :error="$v.auth.username"
        @blur="$v.auth.username.$touch()"
        placeholder="Введите пользователя"
      ></BaseInput>
    </div>
    <div class="form__input-wrapper">
      <BaseInput
        v-model="auth.password"
        name="password"
        type="password"
        :hasError="$v.auth.password.$error"
        label="Пароль"
        :error="$v.auth.password"
        @blur="$v.auth.password.$touch()"
        placeholder="Введите пароль"
      ></BaseInput>
    </div>
    <pre></pre>
    <BaseButton
      type="submit"
      color="blue"
      :disabled="$v.$invalid || isSubmitting"
      class="login__button"
      >Войти</BaseButton
    >
  </form>
</template>

<script>
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import { actionTypes } from "@/store/modules/auth";

export default {
  data() {
    return {
      auth: {
        username: "",
        password: "",
      },
    };
  },
  validations: {
    auth: {
      username: {
        required,
      },
      password: {
        required,
      },
    },
  },
  computed: {
    ...mapState({
      isAuthMobileForm: (state) => state.auth.isAuthMobileForm,
      isSubmitting: (state) => state.auth.isSubmitting,
    }),
  },
  methods: {
    async onSubmit() {
      this.$store.dispatch(actionTypes.login, this.auth).then((resp) => {
        if (resp.status === "ok") {
          this.$router.push({ name: "visualAnalytics" });
        } else {
          this.$toast.error(resp.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  &__form {
    max-width: 33rem;
    width: 100%;
    min-height: 34.8rem;
    background: #ffffff;
    border: 1px solid #cce9ff;
    box-sizing: border-box;
    border-radius: 1.6rem;
    padding: 3rem 3rem 3.2rem;

    background: #ffffff;
    box-shadow: 4px 4px 20px rgba(120, 156, 172, 0.4);
    border-radius: 16px;
  }
  &__wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__button {
    margin-top: 16px;
  }

  @media (max-width: 650px) {
    &__form {
      display: none;
    }
  }
}
.form {
  &__title {
    font-weight: 700;
    font-size: 2.2rem;
    text-align: left;
    letter-spacing: -0.02em;
    color: #494949;
    margin-bottom: 2rem;
  }
  &__link {
    font-weight: bold;
    font-size: 14px;
    color: #828282;
    display: block;
    text-align: right;
    text-decoration: underline;
    cursor: pointer;
    &--blue {
      color: #00557c;
      text-decoration: none;
      margin-top: 0;
      display: inline-block;
      margin-left: 7px;
    }
  }
  &__error {
    font-size: 1.2rem;
    color: red;
    visibility: hidden;
    height: 1.3rem;
  }
  &--visible {
    visibility: visible;
  }
  &__label {
    font-weight: 600;
    font-size: 1.4rem;
    color: #494949;
    margin: 1.8rem 0 1rem;
    display: flex;
    align-items: center;
    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
  &__input {
    background: #ffffff;
    border: 1px solid #e7e7e7;
    box-sizing: border-box;
    border-radius: 4rem;
    padding: 12px 20px;
    outline: none;
    font-size: 16px;
    width: 100%;
    &--error {
      border: 1px solid #ff9595;
    }
    &-wrapper {
      display: flex;
      flex-direction: column;
    }
    &::placeholder {
      font-size: 16px;
      line-height: normal !important;
      color: #b8b8b8;
    }
    &:focus {
      outline: none;
      border: 1px solid #46adf4;
    }
  }
  &__item {
    display: flex;
    margin-top: 20px;
    align-items: center;
  }
}
</style>
